import { TableV2 } from '@anytag/shared-atoms';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { useYoutubeCompareVideosTable } from './hooks';
import { InfluencerYoutubeCompareVideosType } from './types';

export interface YoutubeCompareVideosTableProps extends TableData<InfluencerYoutubeCompareVideosType> {
  socialMediaAccountId?: number;
}

export const YoutubeCompareVideosTable = ({
  loading,
  data = [],
  socialMediaAccountId
}: YoutubeCompareVideosTableProps) => {
  const { columns } = useYoutubeCompareVideosTable();

  return (
    <>
      <TableV2 data={data} loading={loading} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId: socialMediaAccountId }))}
      />
    </>
  );
};
